__turbopack_context__.v({
  "border": "vM1oOa_border",
  "borderNone": "vM1oOa_borderNone",
  "colorPrimary": "vM1oOa_colorPrimary",
  "colors": "vM1oOa_colors",
  "contain": "vM1oOa_contain",
  "container": "vM1oOa_container",
  "content": "vM1oOa_content",
  "count": "vM1oOa_count",
  "icon": "vM1oOa_icon",
  "image": "vM1oOa_image",
  "invert": "vM1oOa_invert",
  "label": "vM1oOa_label",
  "nowrap": "vM1oOa_nowrap",
  "padding--none": "vM1oOa_padding--none",
  "size--lg": "vM1oOa_size--lg",
  "size--sm": "vM1oOa_size--sm",
});
